import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export default function Splash () {
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      navigate('/mode')
    }, 5000)
    //    <div className="w-full h-screen bg-black flex">
    //  <div className="grid grid-cols-3 items-stretch">
    //    <div className="flex-3"></div>
    //    <div className="flex-7">
    //      <img src="/cover.png" />
    //    </div>
    //    <div className="flex-3"></div>
    //  </div>
    // </div>
  }, [navigate])

  return (
    <div className='w-screen h-screen bg-black'>
      <img src='/cover.png' className='w-50%' />
    </div>
  )
}
